import { queryOptions } from '@tanstack/react-query';
import MemberService from '@/app/_services/memberService';
import { AcceptAgreementType } from '@/app/_components/services/signup/useSignUpForm';

export const memberQueries = {
  login: () => ({
    mutationKey: ['login'],
    mutationFn: (emailAddress: string, password: string) =>
      MemberService.postLogin(emailAddress, password),
  }),

  loggedInfo: () =>
    queryOptions({
      queryKey: ['loggedInfo'],
      queryFn: () => MemberService.getLoggedInfo(),
    }),

  logout: () => ({ mutationKey: ['logout'], mutationFn: () => MemberService.postLogout() }),

  signup: () => ({
    mutationKey: ['signup'],
    mutationFn: (
      email: string,
      password: string,
      userName: string,
      position: string,
      company: string,
      privateAgreementSelect: boolean,
      acceptAgreement: AcceptAgreementType,
    ) =>
      MemberService.postSignUp(
        email,
        password,
        userName,
        position,
        company,
        privateAgreementSelect,
        acceptAgreement,
      ),
  }),

  updateMember: () => ({
    mutationKey: ['updateMember'],
    mutationFn: (company: string, position: string, userName: string, privateAgreement: boolean) =>
      MemberService.postUpdateMember(company, position, userName, privateAgreement),
  }),

  changePassword: () => ({
    mutationKey: ['changePassword'],
    mutationFn: (password: string, confirmPassword: string) =>
      MemberService.postChangePassword(password, confirmPassword),
  }),

  findPassword: () => ({
    mutationKey: ['findPassword'],
    mutationFn: (emailAddress: string) => MemberService.postFindPassword(emailAddress),
  }),

  resetPassword: () => ({
    mutationKey: ['resetPassword'],
    mutationFn: (memberSrl: number, authKey: string, password: string, confirmPassword: string) =>
      MemberService.postResetPassword(memberSrl, authKey, password, confirmPassword),
  }),

  memberLeave: () => ({
    mutationKey: ['memberLeave'],
    mutationFn: (password: string) => MemberService.postMemberLeave(password),
  }),

  resendAuthEmail: () => ({
    mutationKey: ['resendAuthEmail'],
    mutationFn: (emailAddress: string) => MemberService.postResendAuthEmail(emailAddress),
  }),

  authEmail: () => ({
    mutationKey: ['authEmail'],
    mutationFn: (memberSrl: number, authKey: string) =>
      MemberService.postAuthEmail(memberSrl, authKey),
  }),
};
